import request from '@/utils/request'

/* store binding settings */
// 获取绑定的店铺
export function getBindStore(storeCode: string) {
  return request({
    url: `/api/store/manage/info/${storeCode}`,
    method: 'get'
  })
}

// 获取剩余可选国家
export function getRemainCountry(list: Array<string>) {
  return request({
    url: `/api/country/manage/get-available?selected=${list}`,
    method: 'get'
  })
}

// 获取支付渠道
export function getPaymentList(storeCode: string, list: Array<string>) {
  return request({
    url: `/api/store/manage/payment-channels?countries=${list}&storeCode=${storeCode}`,
    method: 'get'
  })
}

// 校验店铺访问域名
export function checkStoreDomain(data: { storeName: string; storeCode?: string }) {
  return request({
    url: '/api/store/manage/domain-check',
    method: 'post',
    headers: {
      hideMsg: 'true'
    },
    data
  })
}

// 保存店铺信息
export function saveStoreInfo(data: any) {
  return request({
    url: `/api/store/manage/save`,
    method: 'post',
    headers: {
      userCode: 'ytf'
    },
    data
  })
}

// 获取店铺催付配置
export function getStoreUrgeList(code: any) {
  return request({
    url: `/api/store/manage/dunning/settings?storeCode=${code}`,
    method: 'get'
  })
}

// 保存店铺催付配置
export function saveStoreUrge(data: any) {
  return request({
    url: `/api/store/manage/dunning/save`,
    method: 'post',
    data
  })
}

/* pixel */
// 获取像素列表
export function getPixelList(storeCode: string) {
  return request({
    url: `/api/store/manage/${storeCode}/pixels`,
    method: 'get'
  })
}

// 保存像素
export function savePixel(data: any) {
  return request({
    url: `/api/store/manage/pixel/save`,
    method: 'post',
    data
  })
}

// 编辑像素
export function editPixel(data: any) {
  return request({
    url: `/api/store/manage/pixel/batch`,
    method: 'post',
    data
  })
}

/* 催付设置 */
// 获取催付设置
export function getDomainList(storeCode: string) {
  return request({
    url: `/api/domain/list?storeCode=${storeCode}`,
    method: 'get'
  })
}

// 删除催付设置
export function delDomainData(storeCode: string) {
  return request({
    url: `/api/domain/delete?storeCode=${storeCode}`,
    method: 'get'
  })
}

// 新增/更新 催付设置
export function addDomainData(data: any) {
  return request({
    url: `/api/domain/add`,
    method: 'post',
    data
  })
}

// 验证 催付设置
export function verifyDomainData(storeCode: string) {
  return request({
    url: `/api/domain/verifyDomain?storeCode=${storeCode}`,
    method: 'get'
  })
}

/**
 * 获取用户认证状态
 */
export function getUserAccountVerifyStatus() {
  return request({
    url: `/api/user/manage/verify/status`,
    method: 'get'
  })
}

export function submitUserAccountVerify(data: any) {
  return request({
    url: `/api/user/manage/verify/receive`,
    method: 'post',
    data
  })
}

// 获取审核列表
export function getManageStoreList(data: any) {
  return request({
    url: `/api/compliance/manage/page`,
    method: 'post',
    data
  })
}

//提交审核
export function submitManage(id: string, data: any) {
  return request({
    url: `api/compliance/manage/submit/${id}`,
    method: 'post',
    data
  })
}

// 保存样式
export function saveExtraSetting(data: any) {
  return request({
    url: `/api/store/manage/saveExtraSettings`,
    method: 'post',
    data
  })
}

export function queryExtraSetting(storeCode: any) {
  return request({
    url: `/api/store/manage/getExtraSettings/${storeCode}`,
    method: 'get'
  })
}
